import {Component, Vue} from "vue-property-decorator";

@Component
export class Loader extends Vue {
  render() {
    return <p>Chargement</p>;
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-ce177c82/loader.tsx" });